const initialState = {
  newOrganizationForm: false,
  orgId: null,
  orgKey: null,
  organizationName: null,
  alternateName: null,
  accountingContactId: '',
  facilityCoordinatorContactId: '',
  orgCity: '',
  parentOrganizationId: '',
  administrativeContactId: '',
  invoiceVerificationContactId: '',
  wCare: false,
  parole: false,
  prison: false,
  other: false,
  cbp: false,
  sap: false,
  stop: false,
  vendor: false,
  inactive: false,
  orgDateCreate: null,
  orgDateEdit: null,
  orgCreatedById: '',
  orgEditedById: '',
};
export default initialState;
